import React from 'react';
import { Grid, Stack } from '@mui/material';
import InputField from 'dashboard/components/fields/InputField';

/**
 * Tab 2 — payout bank info (account number, IBAN, SWIFT, account
 * holder name, bank name).
 *
 * All optional: a brand is created and edited without any of this, and the
 * details are only needed once it starts taking money. See the note on
 * `REQUIRED_FIELDS` in ./constants.js.
 */
export default function BankInfoTab({ commonProps }) {
  return (
    <Grid container spacing='20px'>
      <Grid item xs={12} md={6}>
        <Stack direction='column' spacing='20px'>
          <InputField {...commonProps('bank_info.account_number')} placeholder='Account Number' label='Account Number' />
          <InputField {...commonProps('bank_info.IBAN')}           placeholder='IBAN'           label='IBAN' />
          <InputField {...commonProps('bank_info.SWIFT')}          placeholder='SWIFT'          label='SWIFT' />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <Stack direction='column' spacing='20px'>
          <InputField {...commonProps('bank_info.name')}     placeholder='Name'      label='Name' />
          <InputField {...commonProps('bank_info.bankName')} placeholder='Bank Name' label='Bank Name' />
        </Stack>
      </Grid>
    </Grid>
  );
}
